import Vue from "vue";
import Router from "vue-router";
import Home from "./views/Home.vue";
import Meta from "vue-meta";

Vue.use(Router);
Vue.use(Meta);

export default new Router({
    mode: "history",
    base: process.env.BASE_URL,
    scrollBehavior() {
        return {x: 0, y: 0};
    },
    routes: [
        {
            path: "/",
            name: "home",
            component: Home
        },
        {
            path: "/careers",
            redirect: "/vacancies"
        },
        {
            path: "/services",
            name: "services",
            component: () =>
                import(/* webpackChunkName: "services" */ "./views/Services.vue")
        },
        {
            path: "/about",
            name: "about",
            component: () =>
                import(/* webpackChunkName: "about" */ "./views/About.vue")
        },
        {
            path: "/contact",
            name: "contact",
            component: () =>
                import(/* webpackChunkName: "contact" */ "./views/Contact.vue")
        },
        {
            path: "/vacancies",
            name: "vacancies",
            redirect: "/vacancies/open",
            component: () =>
                import(/* webpackChunkName: "vacancies" */ "./views/Vacancies.vue"),
            children: [
                // {
                //     path: "/vacancies/programma_manager",
                //     name: "vacancies-programma_manager",
                //     component: () =>
                //         import(/* webpackChunkName: "vacanciesOpen" */ "./views/vacancies/ProgrammaManager.vue"),
                // },
                {
                    path: "/vacancies/open",
                    name: "vacancies-open",
                    component: () =>
                        import(/* webpackChunkName: "vacanciesOpen" */ "./views/vacancies/Open.vue"),
                }
            ]
        },
        {
            path: "/policy",
            name: "policy",
            redirect: "/policy/cookie",
            component: () =>
                import(/* webpackChunkName: "policy" */ "./views/Policy.vue"),
            children: [
                {
                    path: "/policy/cookie",
                    name: "cookie",
                    component: () =>
                        import(/* webpackChunkName: "policyCookie" */ "./views/policies/Cookie.vue")
                },
                {
                    path: "/policy/privacy",
                    name: "privacy",
                    component: () =>
                        import(/* webpackChunkName: "policyPrivacy" */ "./views/policies/Privacy.vue")
                }
            ]
        },
        {
            path: '/login',
            name: 'login',
            beforeEnter(to, from, next) {
                // Put the full page url including the protocol http(s) below
                window.location = 'https://tms.swbase.com';
            }
        }
    ]
});
